"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDfpNetworksModalComponent = exports.UpdateDfpNetworksModalContext = void 0;
const core_1 = require("@angular/core");
const bootstrap_1 = require("angular2-modal/plugins/bootstrap");
const angular2_modal_1 = require("angular2-modal");
class UpdateDfpNetworksModalContext extends bootstrap_1.BSModalContext {
}
exports.UpdateDfpNetworksModalContext = UpdateDfpNetworksModalContext;
let UpdateDfpNetworksModalComponent = class UpdateDfpNetworksModalComponent {
    constructor(dialog) {
        this.dialog = dialog;
        this.showRawJsonDiff = false;
        this.updated = false;
        this.context = dialog.context;
        this.organization = this.context.organization;
    }
    hasUpdated(dfpNetworkCodes) {
        this.dfpNetworkCodes = dfpNetworkCodes;
        this.updated = true;
    }
    close() {
        this.dialog.close({ hasUpdated: this.updated });
    }
};
exports.UpdateDfpNetworksModalComponent = UpdateDfpNetworksModalComponent;
exports.UpdateDfpNetworksModalComponent = UpdateDfpNetworksModalComponent = __decorate([
    (0, core_1.Component)({
        selector: 'update-dfp-networks-modal',
        templateUrl: 'app/update-dfp-networks-modal.component.html'
    }),
    __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
], UpdateDfpNetworksModalComponent);
//# sourceMappingURL=update-dfp-networks-modal.component.js.map